export const orderViews = {
  BWT: 'BWT',
  Menu: 'Menu',
}
